// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from "react-intl";

import MasterClass from "../assets/icons/co-present.svg";

const icons = {
  masterclass: () => <img src={MasterClass} alt="masterclass icon" />,
};
// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const masterclass = {
  id: "masterclass",
  title: <FormattedMessage id="masterclass" />,
  type: "group",
  url: "/masterclass",
  icon: icons.masterclass,
  disabled: false,
};

export default masterclass;
